var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbitrationCourt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 64,
    viewBox: "0 0 61 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.937866 64.0001V59.0001H40.9379V64.0001H0.937866ZM19.4379 46.3334L0.937866 27.8334L6.7712 21.8334L25.4379 40.3334L19.4379 46.3334ZM40.6045 25.1667L22.1045 6.50008L28.1045 0.666748L46.6045 19.1667L40.6045 25.1667ZM57.4379 60.6667L12.7712 16.0001L16.2712 12.5001L60.9379 57.1667L57.4379 60.6667Z",
    fill: "#708130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrationCourt);
export default __webpack_public_path__ + "static/media/arbitration-court.1e346dfcbfb23c63c12fa0df609e1b24.svg";
export { ForwardRef as ReactComponent };